import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';

export interface PromotionItem {
	id: string;
	type: 'sqtv' | 'qtv' | 'ft' | 'pre-roll';
	shortName: string;
}

export function usePreRollExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_PRE_ROLL_GRID');
	const { country } = storeToRefs(useLanguageStore());

	function setPreRollTags(url: ClickoutUrl, placement: 'ft' | 'qtv', shortName: string, inline?: boolean) {
		if (!variant.value || inline) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: country.value,
			placement,
			providerShortName: shortName,
		});

		url.set('uct_ctag', tag);

		return url;
	}

	return {
		setPreRollTags,
	};
}
